module.exports = __webpack_public_path__ + "static/img/step02.a31f4e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv025/step02.jpg
// module id = sokb
// module chunks = 0